import { TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {
	calculateMinutesFromTime,
	formatInstallationTime,
} from "../../../utils/helpers";

const DurationTextField = ({ value, onDurationChange, resetKey, ...props }) => {
	const [inputValue, setInputValue] = useState(formatInstallationTime(value));
	const [isValid, setIsValid] = useState(true);

	useEffect(() => {
		setInputValue(formatInstallationTime(value));
		setIsValid(true);
	}, [value, resetKey]);

	const handleChange = (event) => {
		const nextValue = event.target.value;
		const isCompleteDuration = /^\d+:\d{2}:\d{2}$/.test(nextValue);
		const seconds = isCompleteDuration
			? calculateMinutesFromTime(nextValue)
			: null;

		setInputValue(nextValue);
		setIsValid(seconds !== null);
		onDurationChange(seconds);
	};

	return (
		<TextField
			{...props}
			type="text"
			value={inputValue}
			onChange={handleChange}
			error={!isValid}
			helperText={
				isValid
					? "Formato hh:mm:ss. Admite más de 24 horas."
					: "Introduce una duración válida (hh:mm:ss)."
			}
			inputProps={{
				inputMode: "numeric",
				pattern: "[0-9]*:[0-9]{2}:[0-9]{2}",
				placeholder: "Ej. 24:00:00",
			}}
		/>
	);
};

export default DurationTextField;
